import { render, staticRenderFns } from "./InvoicePositionsPosition.vue?vue&type=template&id=48f46b21&scoped=true"
import script from "./InvoicePositionsPosition.vue?vue&type=script&lang=ts&setup=true"
export * from "./InvoicePositionsPosition.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./InvoicePositionsPosition.vue?vue&type=style&index=0&id=48f46b21&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f46b21",
  null
  
)

export default component.exports